<footer class="sticky-footer">
  <div class="container my-auto">
    <div class="copyright text-center my-auto">
      <span>Powered by &copy; Escritha {{yearText}}</span>
    </div>
  </div>
</footer>
